import { useQueries } from 'react-query';
import axiosInstance from './axiosInstance';

const useMultipleFetch = (multipleQueries) => {
    const fetchData = (props) => {
        return axiosInstance('GET', props.path, props.params, 'application/json', multipleQueries.baseUrl);
    };
    
    return useQueries(
        multipleQueries.map((element, index) => { return {queryKey: ['post', element.id], queryFn: () => fetchData(element)} })
    )
};

export default useMultipleFetch;